export const fulfilled = (state, action) => ({
  ...state,
  email: action.email,
});

export const resetEmail = state => ({
  ...state,
  email: '',
});
